import { useState, useEffect, useCallback } from "react";
import { Phone, RefreshCw, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { NumberRow } from "@/components/admin/NumberRow";

export const PhoneNumbersCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [add, setAdd] = useState("");
  const load = useCallback(() => api.get("/api/callcenter/numbers").then(r => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const sync = async () => {
    setBusy(true);
    try { const { data } = await api.post("/api/callcenter/numbers/sync"); toast.success(`Found ${data.found} number${data.found === 1 ? "" : "s"} in Telnyx (${data.added} new)`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't reach Telnyx"); } finally { setBusy(false); }
  };
  const addOne = async () => {
    try { await api.post("/api/callcenter/numbers", { number: add }); setAdd(""); toast.success("Number added"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't add that number"); }
  };
  if (!d) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm mt-4 max-w-3xl" data-testid="phone-numbers-card">
      <div className="flex items-center gap-2 mb-1"><Phone className="w-5 h-5 text-blue-600" /><h3 className="font-bold text-slate-900 flex-1">Phone numbers</h3>
        <button onClick={sync} disabled={busy} className="text-sm font-semibold bg-slate-900 hover:bg-slate-800 text-white px-3 py-1.5 rounded-lg flex items-center gap-1.5 disabled:opacity-50" data-testid="numbers-sync-btn"><RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />Pull from Telnyx</button></div>
      <p className="text-sm text-slate-500 mb-4">Give each rep their own caller ID, and choose what happens when someone calls each number: ring your reps, always forward, or forward after hours.</p>
      <div className="space-y-3" data-testid="numbers-list">
        {d.numbers.length === 0 && <p className="text-sm text-slate-400 py-4 text-center" data-testid="numbers-empty">No numbers yet — tap “Pull from Telnyx” to load the numbers you own.</p>}
        {d.numbers.map(n => <NumberRow key={`${n.id}-${n.updated_at || ""}-${n.connection_id || ""}-${n.is_default}`} n={n} reps={d.reps} voices={d.voices} appId={d.app_id} onChange={load} />)}
      </div>
      <div className="flex gap-2 mt-4">
        <input value={add} onChange={e => setAdd(e.target.value)} placeholder="Add a number by hand" className="flex-1 border border-slate-200 rounded-lg px-3 py-1.5 text-sm" data-testid="numbers-add-input" />
        <button onClick={addOne} disabled={!add.trim()} className="text-sm font-semibold border border-slate-200 hover:bg-slate-50 px-3 py-1.5 rounded-lg flex items-center gap-1 disabled:opacity-40" data-testid="numbers-add-btn"><Plus className="w-4 h-4" />Add</button>
      </div>
    </div>
  );
};
